.modalRoot {
  max-width: 500px;
  min-height: 750px;
  width: 100%;
  overflow-y: auto;
}

.root {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.wrap {
  width: 100%;
}

.main {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
